import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowBack,
  MdArrowBackIos,
  MdArrowBackIosNew,
  MdArrowForward,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdClose,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdSend,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Chat.css";
import Spinner from "../components/Spinner";
import { useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import { useRef } from "react";

export default function Chat({
  apiURL,
  isMobile,
  chats,
  setChats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeOperator,
  documents,
  messages,
  setMessages,
  tasks,
  setTasks,
  redirectionPlusOne,
  setRedirectionPlusOne,
  activeContact,
  setActiveContact,
  plans,
}) {
  const [showMedia, setShowMedia] = useState(false);
  const [showSecondTopnav, setShowSecondTopnav] = useState(false);
  const [thisMessages, setThisMessages] = useState([]);
  const [inputString, setInputString] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();
  const { id } = useParams();

  // Initialisierung: Chat erstellen, falls nötig
  useEffect(() => {
    async function initChat() {
      if (id == 0 && !isEmpty(user) && !isEmpty(activeOperator)) {
        await createNewChat(user.id, activeOperator.id);
      }
      if (isEmpty(activeOperator) && isEmpty(activeContact)) {
        // @TODO anhand des active operators die chat id rausholen und dann navigate zu der chat ID
        navigate("/");
      }
    }
    initChat();
  }, [id, user, activeOperator]);

  useEffect(() => {
    let helpArr = [];
    let needUpdate = false;
    let msgCopy = [...messages];

    if (!isEmpty(msgCopy)) {
      if (isEmpty(activeContact)) {
        msgCopy.forEach((msg) => {
          if (msg.chats_id === id) {
            if (msg.seen == 0 || msg.seen == "0") {
              msg.seen = 1;
              needUpdate = true;
            }
            helpArr.push(msg);
          }
        });
      } else if (!isEmpty(activeContact)) {
        console.log(activeContact);
        msgCopy.forEach((msg) => {
          if (msg.chats_id === id && msg.sender == activeContact) {
            if (msg.seen == 0 || msg.seen == "0") {
              msg.seen = 1;
              needUpdate = true;
            }
            helpArr.push(msg);
          }
        });
      }
    }

    if (needUpdate) {
      updateMessages();
    }
    setThisMessages(helpArr);
    scrollToRef();

    if (id === 0 && isEmpty(activeOperator)) {
      navigate("/");
    }
  }, [messages, id, activeOperator]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        addMessage(inputString);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Aufräumen beim Unmounten des Components:
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [id, inputString]);

  const addMessage = (message, sender) => {
    let helpArr = [...messages];
    let newMessage = {
      id: 0,
      message: message,
      createdAt: Math.floor(Date.now() / 1000),
      chats_id: id,
      users_id: sender != "ai" ? 1 : 0,
      sender: "user",
    };
    helpArr.push(newMessage);
    setMessages(helpArr);
    sendMessage(message, id, user.id);
    setInputString("");
  };

  // Async Chat-Erstellung
  const createNewChat = async (user_id, active_operator_id) => {
    try {
      const response = await fetch(apiURL + "/api/chats/createChat.php?", {
        method: "PUT",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          users_id: user_id,
          operators_id: active_operator_id,
        }),
      });
      const text = await response.text();
      setRedirectionPlusOne(true);
      if (!chats.some((chat) => chat.id === JSON.parse(text).id)) {
        setChats([...chats, JSON.parse(text)]);
      }
      navigate("/chats/" + JSON.parse(text).id);
    } catch (error) {
      console.error(error);
    }
  };

  const updateMessages = async () => {
    try {
      const response = await fetch(
        apiURL + "/api/messages/mark_messages_as_seen.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );
      const result = await response.json();
      console.log("Server Antwort:", result);
    } catch (error) {
      console.error("Fehler beim Senden:", error);
    }
  };

  const sendMessage = async (message, chats_id, users_id) => {
    // Erstellen des FormData-Objekts
    const formData = new FormData();
    formData.append("message", message);
    formData.append("chats_id", chats_id);
    formData.append("users_id", users_id);
    formData.append("operators_id", activeOperator.id);

    try {
      const response = await fetch(
        "https://www.cloud.ditochat.com/api/messages/new_userMessage.php",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP-Fehler: ${response.status}`);
      }

      const data = await response.json();
      console.log("Erfolgreiche Antwort:", data);
    } catch (error) {
      console.error("Fehler beim Senden der Nachricht:", error);
    }
  };

  const targetRef = useRef(null);

  const scrollToRef = () => {
    setTimeout(() => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Verzögerung von 0,2 Sekunde
  };

  function RenderTextWithImage(text) {
    const regex = /(https?:\/\/[^\s]+\.(?:png|jpg))/i;
    const match = text.match(regex);

    if (match) {
      const imageUrl = match[0];
      const beforeImage = text.split(imageUrl)[0];

      return (
        <div style={{ width: "100%" }}>
          <img
            src={imageUrl}
            alt="embedded"
            style={{ width: "100%", objectFit: "cover" }}
          />
          {beforeImage}
        </div>
      );
    } else {
      return <>{text}</>;
    }
  }

  return (
    <div className="chat">
      <div className="chat_topnav">
        <div className="chat_topnav_left">
          <div
            className="chat_topnav_backbtn"
            onClick={() => (redirectionPlusOne ? navigate(-2) : navigate(-1))}>
            <ArrowBackIcon />
          </div>
          <div className="chat_topnav_thumbnail">
            <img
              src={activeOperator?.img_url}
              className="chat_topnav_thumbnail_img"
            />
            {activeOperator?.name}
          </div>
        </div>
        <div className="chat_topnav_right">
          <div
            className="chat_topnav_tasks"
            onClick={() => setShowMedia(!showMedia)}>
            {showMedia ? <CloseIcon /> : "Medien"}
          </div>
        </div>
      </div>
      {showSecondTopnav && (
        <div className="chat_secondtopnav">
          <div className="chat_secondtopnav_left">
            <div className="chat_secondtopnav_left_bold">Filter: </div>
            <div className="chat_secondtopnav_left_filter">
              Email Automatisierung
            </div>
          </div>
          <div
            className="chat_secondtopnav_right"
            onClick={() => setShowSecondTopnav(false)}>
            <CloseIcon />
          </div>
        </div>
      )}

      {showMedia ? (
        <div className="chat_body">
          <div className="chat_body_messageBoxAI" key={"media + index"}>
            <div className="chat_body_messageBoxAI_message">Media Element</div>
          </div>
        </div>
      ) : (
        <div className="chat_body">
          {isEmpty(activeContact) && (
            <div
              className="chat_body_messageBoxAI"
              key={"aiintro" + activeOperator?.id}>
              <div className="chat_body_messageBoxAI_message">
                {!isEmpty(plans) && JSON.parse(plans[0].qna)[0].q}
              </div>
            </div>
          )}

          {thisMessages.map((msg, index) => (
            <>
              {msg.sender != "user" ? (
                <div
                  className="chat_body_messageBoxAI"
                  key={msg.id + "ai" + index + msg.message}>
                  <div className="chat_body_messageBoxAI_message">
                    {RenderTextWithImage(msg.message)}
                    {msg.automations_content && (
                      <div className="">
                        ---------- <br />
                        {msg.automations_content}
                        <br />
                        ---------- <br />
                        <div className="chat_body_messageBoxAI_message_sendDraft">
                          Senden
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="chat_body_messageBoxUser"
                  key={msg.id + "user" + index + msg.message}>
                  <div className="chat_body_messageBoxUser_message">
                    {msg.message}
                  </div>
                </div>
              )}
            </>
          ))}
          <div ref={targetRef}></div>
        </div>
      )}

      <div className="chat_bottombar">
        <div className="chat_bottombar_uploadbtn">
          <AddIcon />
        </div>
        <input
          className="chat_bottombar_input"
          placeholder="Schreibe eine Nachricht"
          value={inputString}
          onChange={(e) => setInputString(e.target.value)}
        />
        {id == 0 ? (
          <div className="chat_bottombar_sendbtn">
            <Spinner />
          </div>
        ) : (
          <div
            className="chat_bottombar_sendbtn"
            onClick={() => addMessage(inputString)}>
            <SendIcon />
          </div>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const SendIcon = styled(MdSend)`
  font-size: 25px;
  color: #ffffff;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #717171;
`;

const ArrowForwardIcon = styled(MdArrowForward)`
  font-size: 15x;
  color: #717171;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 25px;
  color: #717171;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const CloseIcon = styled(MdClose)`
  font-size: 25px;
  color: #717171;
`;
